import React from 'react';
import SliderBabyRightsite from "./swiper/sliderBabyRightsite";

export default function ({ sideBarData, eleRef }) {
    console.log("SliderBabyRightsite sideBarData ==",sideBarData);
    console.log("SliderBabyRightsite eleRef ==",eleRef);
    return (
      <div>
      {eleRef.state.loggedin && !eleRef.state.isMobile &&
      <section className="slideTemp baby-slide-third-section">
          <SliderBabyRightsite page={"dr-carousel-unit"} data={sideBarData} eleRef={eleRef} />
      </section>}

     

      </div>
    ) 
}
